import { render, staticRenderFns } from "./TestReportResult.vue?vue&type=template&id=4efc3b1a&scoped=true"
import script from "./TestReportResult.vue?vue&type=script&lang=js"
export * from "./TestReportResult.vue?vue&type=script&lang=js"
import style0 from "./TestReportResult.vue?vue&type=style&index=0&id=4efc3b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efc3b1a",
  null
  
)

export default component.exports